import type { useIntl } from 'react-intl'
import { toast } from 'react-toastify'

import { showSnackbar } from '@b-stock/fe-core/bstock-react'

import type { BulkAddToWatchlistResult } from './useBulkAddToWatchlist'

type FormatMessage = ReturnType<typeof useIntl>['formatMessage']

type BulkAddToWatchlistMessageIds = {
  success: string
  partialSuccess: string
}

// Shared toast presentation for the bulk "Add to Watchlist" result, reused by
// both the ALP/Storefront dropdown (BulkActionsBar) and the My Bids toolbar
// so copy, toast styling, and dismiss timing stay identical across surfaces.
export function showBulkAddToWatchlistToast(
  { addedCount, failedCount, attempted }: BulkAddToWatchlistResult,
  formatMessage: FormatMessage,
  messageIds: BulkAddToWatchlistMessageIds
) {
  // Nothing to report if every selected listing was already watchlisted.
  if (attempted === 0) return

  if (failedCount === 0) {
    const content = formatMessage(
      { id: messageIds.success },
      { count: addedCount }
    )
    const id = showSnackbar({
      content,
      options: { type: 'success', autoClose: true },
    })
    // SnackbarContainer's hideProgressBar suppresses the CSS animation that
    // drives react-toastify's built-in auto-dismiss; setTimeout is a hard-deadline fallback.
    setTimeout(() => toast.dismiss(id), 6_000)
    return
  }

  const content = formatMessage(
    { id: messageIds.partialSuccess },
    { succeeded: addedCount, total: attempted }
  )
  const id = showSnackbar({
    content,
    options: {
      type: failedCount === attempted ? 'error' : 'default',
      autoClose: 'long',
    },
  })
  setTimeout(() => toast.dismiss(id), 10_000)
}
